import { PropsWithChildren, useContext, useState, createContext } from 'react';
import { useIsFetching, useIsMutating } from 'react-query';
import { Loading } from 'components';

type LoadingContextType = [boolean, React.Dispatch<React.SetStateAction<boolean>>];
const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider = ({ children }: Readonly<PropsWithChildren<unknown>>) => {
  const loadingState = useState(false);
  const [isLoading] = loadingState;

  const fetchingCount = useIsFetching();
  const mutatingCount = useIsMutating();

  const shouldShowLoading = isLoading || fetchingCount > 0 || mutatingCount > 0;

  return (
    <LoadingContext.Provider value={loadingState}>
      {shouldShowLoading && <Loading />}
      {children}
    </LoadingContext.Provider>
  );
};

export const useIsLoading = () => {
  const loadingState = useContext(LoadingContext);
  if (!loadingState) {
    throw new Error('useIsLoading must be used within a LoadingProvider');
  }

  return loadingState;
};
